import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import firebase from 'firebase/app'
// Só a autenticação: o pacote "firebase" inteiro (firestore, storage...) não é usado e gerava o
// aviso "using the development build of the Firebase JS SDK" no console
import 'firebase/auth'
import VueKonva from 'vue-konva'
import vuetify from './plugins/vuetify';
import VuePrlx from 'vue-prlx'
import VueSweetalert2 from 'vue-sweetalert2';
import 'animate.css/animate.min.css';
Vue.use(VuePrlx);
Vue.use(VueSweetalert2);

Vue.config.productionTip = false
Vue.use(VueKonva)
var firebaseConfig = {
  apiKey: process.env.VUE_APP_apiKey,
  authDomain: process.env.VUE_APP_authDomain,
  databaseURL: process.env.VUE_APP_databaseURL,
  projectId: process.env.VUE_APP_projectId,
  storageBucket: process.env.VUE_APP_storageBucket,
  messagingSenderId: process.env.VUE_APP_messagingSenderId,
  appId: process.env.VUE_APP_appId,
  measurementId: process.env.VUE_APP_measurementId
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// firebase.analytics();
window.firebase = firebase;

import store from './store'

let app = '';
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      vuetify,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
});

